import VueRouter from 'vue-router'
import Vue from 'vue'
import Home from '../pages/home.vue'
import Login from '../pages/login.vue'
import ClassRoom from '../pages/classRoom.vue'
import BackLive from '../pages/backLive.vue'

Vue.use(VueRouter)
const routes = [
    { path: '/', component: Home },
    { path: '/login', component: Login },
    { path:'/room',component:ClassRoom},
    { path:'/backlive',component:BackLive},
    { path:'/liveRoom',component:ClassRoom}
]


// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
const router = new VueRouter({
    routes // (缩写) 相当于 routes: routes
  })

//路由拦截
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(localStorage.getItem('token')) ||{}
  
  if (to.path === '/login') {
      if (userInfo?.id) {
          next('/')
      } else {
          next()
      }
  } else {
      if (userInfo?.id) {
          next()
      } else {
          next('/login')
      }
  }
})

export default router